import React from "react";
import { reportClientError } from "../config/api";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    reportClientError({
      type: "react-boundary",
      message: error.message,
      stack: error.stack,
      componentStack: info.componentStack,
    });
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "var(--bg, #f9fafb)",
          padding: 32,
        }}
      >
        <div
          style={{
            maxWidth: 480,
            width: "100%",
            background: "#fff",
            border: "1px solid var(--border-strong)",
            borderRadius: 16,
            padding: "40px 36px",
            textAlign: "center",
            boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
          }}
        >
          <div style={{ fontSize: 48, marginBottom: 16 }}>⚠️</div>
          <h2
            style={{
              fontSize: 20,
              fontWeight: 700,
              color: "var(--text)",
              marginBottom: 10,
            }}
          >
            Something went wrong
          </h2>
          <p
            style={{
              fontSize: 14,
              color: "var(--text-2)",
              lineHeight: 1.6,
              marginBottom: 24,
            }}
          >
            An unexpected error occurred. The issue has been reported
            automatically. Please reload the page to continue.
          </p>
          {this.state.error?.message && (
            <pre
              style={{
                fontSize: 11,
                background: "var(--danger-bg)",
                border: "1px solid #fecaca",
                borderRadius: 8,
                padding: "10px 14px",
                color: "var(--danger-text)",
                textAlign: "left",
                overflowX: "auto",
                marginBottom: 24,
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {this.state.error.message}
            </pre>
          )}
          <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "9px 20px",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 600,
                background: "#1d4ed8",
                color: "#fff",
                border: "none",
                cursor: "pointer",
              }}
            >
              Reload page
            </button>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.history.back();
              }}
              style={{
                padding: "9px 20px",
                borderRadius: 8,
                fontSize: 14,
                fontWeight: 600,
                background: "var(--surface-3)",
                color: "var(--text-2)",
                border: "1px solid var(--border-strong)",
                cursor: "pointer",
              }}
            >
              Go back
            </button>
          </div>
        </div>
      </div>
    );
  }
}
